import classnames from 'classnames';
import { generateCompStylers, getStylePropsFunc } from '../../../../../common/utils/styles';
import DropdownElement from '../../../../../hybrid/library/DropdownElement';
import FormInput from '../../../../form/components/form-input/FormInput/FormInput';
import { t } from '../../../../../common/components/T';
import ExcelButton from '../../../../excelButton/ExcelButton';
import { svgSprite } from '../../../../../hybrid/wrappers';
import Counter from '../../Counter';
import SelectElement from '../../SelectElement';

const CounterHead = ({
    setShowModal,
    transl,
    compStyles,
    screenWidth,
    textsData,
    pageSettings,
    inputGlobFilter,
    globalSearch,
    selectPageConfig,
    exportData,
    dataFiltersToUrl
}) => {
    const getStyleProps = (...keys) => getStylePropsFunc(compStyles, ...keys);
    const { stylers, classes } = generateCompStylers(compStyles);

    return (
        <>
            <div
                style={{
                    ...stylers.tableButtonsBlock,
                    ...stylers.adminHeadWrapper
                }}
                className={classnames(classes.tableButtonsBlock, classes.adminHeadWrapper)}
            >
                {pageSettings.structure === 'counter-head' ? (
                    !screenWidth && (
                        <div {...getStyleProps('flexRow', 'adminFilterTitle', 'adminFilterTitleWidth')}>
                            <p>{textsData.globalSearthPlaceholderLabel || textsData.globalSearthPlaceholder}</p>
                        </div>
                    )
                ) : (
                    <div {...getStyleProps('flexRow')}>
                        {textsData.settingsButton !== false ? (
                            !screenWidth ? (
                                <div>
                                    {/*{svgSprite('gear', {*/} {/*})}*/}
                                    {/*<p>{textsData.settingsButton || t('gridHeader-displaySetting', 'Настройка отображения', 'widget', transl, "gridFilter" )}</p>*/}
                                </div>
                            ) : (
                                <div>
                                    {/*{svgSprite('gear', {*/} {/*})}*/}
                                </div>
                            )
                        ) : textsData.pageTitle ? (
                            <p {...getStyleProps('pageTitleText')}>
                                {textsData.pageTitle ||
                                    t('gridHeader-displaySetting', 'Настройка отображения', 'widget', transl, 'gridFilter')}
                            </p>
                        ) : null}
                    </div>
                )}
                <div {...getStyleProps('flexRow')}>
                    {!screenWidth && (
                        <div {...getStyleProps('searthTable')}>
                            {!pageSettings?.hideSearchInput ? (
                                <>
                                    <FormInput
                                        value={inputGlobFilter?.[0]}
                                        compStyle={{
                                            wrapper: {
                                                ...stylers.searthTableInput,
                                                className: classes.searthTableInput
                                            },
                                            global: { icon: { width: '18px' } },
                                            clear: { icon: { width: '10px' } }
                                        }}
                                        handlers={{
                                            onChange: (val) => {
                                                globalSearch(val);
                                            }
                                        }}
                                        search={{
                                            type: 'onInput',
                                            icon: 'search-thin'
                                        }}
                                        placeholder={
                                            textsData.globalSearthPlaceholder ||
                                            t('gridHeader-searchUser', 'Поиск пользователя', 'widget', transl, 'gridFilter')
                                        }
                                        buttons={
                                            !pageSettings?.hideGlobalSearch
                                                ? {
                                                      global: {
                                                          icon: 'sliders',
                                                          handler: () => setShowModal(true)
                                                      },
                                                      ...(inputGlobFilter?.[0]
                                                          ? {
                                                                clear: {
                                                                    icon: 'cross',
                                                                    handler: () => {
                                                                        globalSearch('');
                                                                    }
                                                                }
                                                            }
                                                          : {})
                                                  }
                                                : {
                                                      ...(inputGlobFilter?.[0]
                                                          ? {
                                                                clear: {
                                                                    icon: 'cross',
                                                                    handler: () => {
                                                                        globalSearch('');
                                                                    }
                                                                }
                                                            }
                                                          : {})
                                                  }
                                        }
                                    />
                                </>
                            ) : (
                                <div
                                    {...getStyleProps('searthFilterOpen', 'searthFilterOpenStatic', 'formCursorPointer')}
                                    onClick={() => setShowModal(true)}
                                >
                                    {svgSprite('search-thin', getStyleProps('userSearthSvgFillGrey'))}
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <Counter compStyles={compStyles} data={pageSettings.counter} />
            </div>
            {pageSettings.selectItem ? (
                <div {...getStyleProps('selectPageWrap')}>
                    <div>
                        <SelectElement
                            selectElementItemsArr={pageSettings.selectItem}
                            compStyles={compStyles}
                            activeElem={pageSettings.activeElem || []}
                            selectData={pageSettings.selectData || {}}
                            translation={transl}
                            setActiveElem={pageSettings?.setActiveElem}
                        />
                    </div>
                    <div {...getStyleProps('selectPageWrapItem')}>
                        <p {...getStyleProps('selectPageText')}>
                            {(screenWidth
                                ? t('gridHeader-selectPageTextXs', 'Записей', 'widget', transl, 'gridFilter')
                                : t('gridHeader-sselectPageText', 'Записей на странице', 'widget', transl, 'gridFilter')) + ':'}
                        </p>
                        <DropdownElement componentConfig={selectPageConfig} />
                        {exportData ? <ExcelButton filter={dataFiltersToUrl} exportData={exportData} /> : null}
                    </div>
                </div>
            ) : (
                <div {...getStyleProps('selectPageWrap')}>
                    <p {...getStyleProps('selectPageText')}>
                        {(screenWidth
                            ? t('gridHeader-selectPageTextXs', 'Записей', 'widget', transl, 'gridFilter')
                            : t('gridHeader-sselectPageText', 'Записей на странице', 'widget', transl, 'gridFilter')) + ':'}
                    </p>
                    <DropdownElement componentConfig={selectPageConfig} />
                    {exportData && (
                        <p {...getStyleProps('counterHeadExportButton')}>
                            <ExcelButton exportData={exportData} filter={dataFiltersToUrl} />
                        </p>
                    )}
                </div>
            )}
        </>
    );
};
export default CounterHead;
